import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suprimir errores de ResizeObserver que ocurren con componentes Radix UI/Shadcn
// Este es un bug conocido del navegador que no afecta la funcionalidad
// Solución: Parchear el ResizeObserver para ignorar errores de loop
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Usar requestAnimationFrame para evitar el error de loop
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// También capturar errores a nivel de window
const resizeObserverError = (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop') ||
    e.message.includes('ResizeObserver loop completed with undelivered notifications')
  )) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
};
window.addEventListener('error', resizeObserverError, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
